var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEstateNew1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xA7\x91\xEC\x95\x84\xEC\x9D\xB4\xEC\xBD\x98",
    filter: "url(#filter0_d_2222_166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M32.4999 15.7894L27.1929 5.24292L20.3381 13.3627V32.2419H32.4999V15.7894Z",
    fill: "#5E676F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23",
    d: "M2.5 15.3672H21.148V32.2415H2.5V15.3672Z",
    fill: "#98A1A9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30",
    x: 8.9856,
    y: 20.4302,
    width: 4.86469,
    height: 5.0623,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 31",
    x: 25.2019,
    y: 22.1172,
    width: 4.05391,
    height: 10.1246,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M27.1147 5.24292H8.855L2.5 15.3675H21.148L27.1147 5.24292Z",
    fill: "#1F2E3D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 424",
    x: 11.1189,
    y: 9.29663,
    width: 15.3269,
    height: 12.8213,
    rx: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 425",
    x: 17.8325,
    y: 14.1172,
    width: 1.89733,
    height: 5.36855,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 337",
    cx: 18.7822,
    cy: 14.1172,
    r: 2.18797,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 105",
    d: "M14.2563 10.9459V6.59689C14.2563 4.0976 16.2824 2.07153 18.7817 2.07153V2.07153C21.281 2.07153 23.3071 4.0976 23.3071 6.59689V10.9459",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2222_166",
    x: 0.5,
    y: 0.571533,
    width: 33.9998,
    height: 35.6704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2222_166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2222_166",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstateNew1);
export default __webpack_public_path__ + "static/media/IcEstateNew_1.74175532af8820702a7b72bf34d8c996.svg";
export { ForwardRef as ReactComponent };